<template>
  <Modal
    :open="displayModal"
    title="Upload FAA Documentation"
    size="large"
    modalIcon="fad fa-drone-alt"
    modalIconColor="bg-blue-100 text-blue-700"
    :showEscapeButton="true"
    :showAcceptButton="true"
    :acceptButtonProgress="isProgressing"
    acceptButtonText="Submit Documentation"
    @close="displayModal = false"
    @onSuccess="submitFaaDoc"
    ref="modal"
  >
    <div>
      If you upload drone video, you must, <strong>first</strong>, upload all
      relevant supporting documentation including FAA license, FAA renewal, and
      all applicable waivers. Here is where you can upload those files
      individually.
    </div>
    <div class="grid grid-cols-1 gap-4 mt-4">
      <div>
        <label class="block text-sm font-medium text-gray-700">
          Document
        </label>
        <input
          type="file"
          class="form-control focus:outline-none"
          v-on:change="fileAdded"
        />
      </div>

      <div>
        <label for="type" class="block text-sm font-medium text-gray-700">
          Type
        </label>
        <select
          id="type"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          v-model="data.type"
        >
          <option value="part107_initial"
            >FAA Part 107 - Certificate (Card)</option
          >
          <option value="part107_recurrent">FAA Part 107 - Recurrent</option>
          <option value="waiver">Waiver</option>
          <option value="laancreq">Airspace Authorization</option>
        </select>
      </div>

      <div>
        <label for="refId" class="block text-sm font-medium text-gray-700">
          {{ data.type | displayFaaEventType }}
        </label>
        <input
          id="refId"
          class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          type="text"
          v-model="data.faaRefId"
        />
      </div>

      <div class="flex flex-row mx-0 md:-mx-2">
        <div class="w-full md:w-1/2 md:mb-0 px-0 md:px-2">
          <label class="block text-sm font-medium text-gray-700">
            Issued At
          </label>
          <input
            type="date"
            id="start"
            name="start"
            class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            v-model="data.issuedAt"
          />
        </div>
        <div class="w-full md:w-1/2 px-0 md:px-2">
          <label class="block text-sm font-medium text-gray-700">
            Expires At
          </label>
          <input
            type="date"
            id="start"
            name="start"
            class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            v-model="data.expiresAt"
          />
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import * as Config from "@/config";

import Modal from "@/components/Modal";

export default {
  data() {
    return {
      displayModal: false,
      data: {
        type: "part107_initial",
        faaRefId: null,
        issuedAt: null,
        expiresAt: null,
        file: null,
        fileExt: null,
        submitting: false
      },
      isProgressing: false
    };
  },

  components: {
    Modal
  },

  mounted() {
    this.$nextTick(
      function() {
        this.$eventBus.$on("settings-faa-upload-open-modal", this.open);
      }.bind(this)
    );
  },

  destroyed() {
    this.$eventBus.$off("settings-faa-upload-open-modal", this.open);
  },

  methods: {
    open(data) {
      this.displayModal = true;
    },

    fileAdded(e) {
      e.preventDefault();
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.data.file = files[0];
      var filename = this.data.file.name;
      this.data.fileExt =
        filename.substring(filename.lastIndexOf(".") + 1, filename.length) ||
        filename;
    },
    async submitFaaDoc() {
      if (this.isProgressing) {
        return;
      }
      this.isProgressing = true;
      var formData = new FormData();
      formData.append("file", this.data.file);
      formData.append("ext", this.data.fileExt);
      formData.append("type", this.data.type);
      formData.append("faaRefId", this.data.faaRefId);
      formData.append("issuedAt", this.data.issuedAt);
      formData.append("expiresAt", this.data.expiresAt);

      try {
        let res = await this.$http.post(
          Config.apiPath + "/api/v2/stringer/account/faadocs",
          formData
        );

        this.$swal(
          "Success!",
          "Your document has been uploaded and saved.",
          "success"
        );
        this.isProgressing = false;
        this.$refs.modal.$emit("closeModalEvent");
      } catch (e) {
        this.isProgressing = false;
        alert(error.response.data.errors);
      }
    }
  }
};
</script>
